import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=5645c7e7&scoped=true&"
import script from "./calendar.vue?vue&type=script&lang=js&"
export * from "./calendar.vue?vue&type=script&lang=js&"
import style0 from "./calendar.vue?vue&type=style&index=0&id=5645c7e7&scoped=true&lang=css&"
import style1 from "./calendar.vue?vue&type=style&index=1&id=5645c7e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5645c7e7",
  null
  
)

export default component.exports